/** Storage path and content type for an encoded avatar: the real format decides both. */

export type AvatarFormat = { ext: 'webp' | 'jpg'; contentType: 'image/webp' | 'image/jpeg' };

const WEBP: AvatarFormat = { ext: 'webp', contentType: 'image/webp' };
const JPEG: AvatarFormat = { ext: 'jpg', contentType: 'image/jpeg' };

/** Safari cannot encode WebP and falls back to JPEG; anything that is not WebP is sent as JPEG. */
export function avatarFormat(blobType: string): AvatarFormat {
  return blobType === 'image/webp' ? WEBP : JPEG;
}

export const avatarPath = (userId: string, format: AvatarFormat): string => `${userId}/avatar.${format.ext}`;

/** The path of the other format, removed after a successful upload so only one file remains. */
export const staleAvatarPath = (userId: string, format: AvatarFormat): string =>
  avatarPath(userId, format === WEBP ? JPEG : WEBP);

export const allAvatarPaths = (userId: string): string[] => [avatarPath(userId, WEBP), avatarPath(userId, JPEG)];
